module.exports = __webpack_public_path__ + "img/one.1641520899224.png";